// Verrou du titre — bloque toute modification par GTranslate
(function () {
  let _title = document.title;
  Object.defineProperty(document, "title", {
    get() {
      return _title;
    },
    set(_) {},
    configurable: true,
  });
})();

// Récupère la langue actuelle utilisée par Google Translate / GTranslate
function getCurrentLangFromCookie() {
  const langCookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith("googtrans="));

  if (langCookie) {
    return langCookie.split("=")[1].split("/")[2]; // ex: "/fr/en" → "en"
  }

  return null;
}

// Affiche / cache éléments
const show = (elements) => {
  Array.from(elements).forEach((el) => el.classList.remove("d-none"));
};

const hide = (elements) => {
  Array.from(elements).forEach((el) => el.classList.add("d-none"));
};

// Gestion des bannières OQLF
const showBaner = (currentLang) => {
  const bannersEn = document.getElementsByClassName("oqlf-banner-english");
  const bannersFR = document.getElementsByClassName("oqlf-banner-french");

  for (let banner of bannersEn) {
    if (currentLang && currentLang !== "fr") {
      banner.classList.remove("d-none");
    } else {
      banner.classList.add("d-none");
    }
  }

  for (let banner of bannersFR) {
    if (currentLang && currentLang !== "fr") {
      banner.classList.add("oqlf-force-french");
    } else {
      banner.classList.remove("oqlf-force-french");
    }
  }
};

// Fonction principale
function showInEnglish() {
  const currentLang = getCurrentLangFromCookie();
  showBaner(currentLang);
}

// Protection du mot Québec (anti-traduction)
function protectQuebec() {
  const regex = /\bQuebec\b/g;

  document.querySelectorAll("body *:not(script):not(style)").forEach((el) => {
    if (el.children.length === 0) {
      if (el.textContent.includes("Quebec")) {
        el.textContent = el.textContent.replace(regex, "Québec");
      }
    }
  });
}

// MutationObserver (Google Translate modifie le DOM)
const observer = new MutationObserver(() => {
  protectQuebec();
});

// Ajoute notranslate sur éléments ciblés
function notranslateElements(classNames) {
  document.addEventListener("DOMContentLoaded", function () {
    classNames.forEach((className) => {
      const elements = document.querySelectorAll(`.${className}`);

      elements.forEach((el) => {
        el.classList.add("notranslate");
        el.setAttribute("translate", "no");
      });
    });
  });
}

// Met à jour l’affichage selon la langue détectée
showInEnglish();

// Empêche certains éléments (menus) d’être traduits
/*notranslateElements(["menu-item-164", "menu-item-155"]);*/

// Observer DOM
observer.observe(document.body, {
  childList: true,
  subtree: true,
  characterData: true,
});

// Surveiller les changements de langue (ex. via Google Translate)
let lastLang = getCurrentLangFromCookie();

setInterval(() => {
  const newLang = getCurrentLangFromCookie();
  if (newLang !== lastLang) {
    lastLang = newLang;
    showInEnglish();
  }
}, 1000); // vérifie toutes les 1 secondes
